import React, { useState } from "react";

import SentRequestsPage from "../sentRequestsPage/sentRequestsPage.tsx";
import UserProfilePage from "../userProfilePage/userProfilePage.tsx";
import MatrimonyList from "../matrimonyList/matrimonyList.tsx";
import UserNavbar from "../../common/navBar/userNavbar.tsx";
import Footer from "../../common/footer/footer.tsx";
import AdminPage from "../adminPage/adminPage.tsx";

const UserList = () => {
  // ✅ DEFAULT TAB = ACTIVE MEMBERS
  const [activeTab, setActiveTab] = useState("members");

  const renderPage = () => {
    switch (activeTab) {
      case "members":
        return <MatrimonyList />;

      case "requests":
        return <SentRequestsPage />;

      case "profile":
        return <UserProfilePage />;

      case "admin":
        return <AdminPage />;

      default:
        return <MatrimonyList />;
    }
  };

  return (
    <>
      <UserNavbar activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className='tab-content'>{renderPage()}</div>
      <Footer />
    </>
  );
};

export default UserList;
